import React, { useState, useEffect } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  MessageOutlined
} from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button, Input, Form, Select, message } from 'antd';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { scoutChatCenterServerUrl } from '../autoConfig';

const AddCousultant = ({ consultantData }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [options, setOptions] = useState([
    {
      value: '',
      label: ''
    }
  ]);
  const [timezone, setTimezone] = useState([
    {
      value: '',
      label: ''
    }
  ]);
  const [messageApi, contextHolder] = message.useMessage();
  const getOption = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/team/getTeams`
      });
      return (
        response.data.teams?.map((item) => ({
          value: item.teamName,
          label: item.teamName
        })) || []
      );
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };
  const getTimezone = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/getAllTimezones`
      });
      return (
        response.data.data?.map((item) => ({
          value: item.office,
          label: item.office + ' ' + item.timezone
        })) || []
      );
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const newOptions = await getOption();
        setOptions(newOptions);
      } catch (error) {
        console.error('Failed to fetch options', error);
      }
    };
    const fetchTimezone = async () => {
      try {
        const newOptions = await getTimezone();
        setTimezone(newOptions);
      } catch (error) {
        console.error('Failed to fetch options', error);
      }
    };
    fetchTimezone();
    fetchOptions();
  }, []);

  countries.registerLocale(enLocale);

  const countryOptions = Object.entries(countries.getNames('en')).map(
    ([code, name]) => ({
      label: name,
      value: code
    })
  );

  useEffect(() => {
    if (consultantData) {
      form.setFieldsValue({
        email: consultantData.email,
        name: consultantData.name,
        role: consultantData.role,
        office: consultantData.office,
        region: consultantData.region,
        country: consultantData.country,
        teams: consultantData.teams.map((item) => item.teamName) // ensure 'teams' is an array of values
      });
    }
  }, [consultantData, form]);

  const onFinish = async (values) => {
    if (consultantData) {
      try {
        const response = await axios({
          method: 'put',
          url: `${scoutChatCenterServerUrl}/consultant/updateConsultant/${consultantData.email}`,
          data: {
            ...values
          }
        });
        if (response) {
          window.location.reload();
        }
        return response;
      } catch (error) {
        messageApi.open({
          type: 'error',
          content: error.message
        });
        console.log('error occurred fetching bot response', error);
        return [];
      }
    } else {
      try {
        const response = await axios({
          method: 'post',
          url: `${scoutChatCenterServerUrl}/consultant/addConsultant`,
          data: {
            ...values
          }
        });
        if (response) {
          window.location.reload();
        }
        return response;
      } catch (error) {
        messageApi.open({
          type: 'error',
          content: error.message
        });
        console.log('error occurred fetching bot response', error);
        return [];
      }
    }

    // onConsultantAdd(false);
  };
  return (
    <div>
      <Form
        layout={{
          labelCol: {
            span: 4
          },
          wrapperCol: {
            span: 14
          }
        }}
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: 'Please input your teamName!'
            }
          ]}
          normalize={(value) => value.trim()}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: 'Please input your teamName!'
            }
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="office"
          label="Time Zone"
          rules={[
            {
              required: true,
              message: 'Please input your Time Zone!'
            }
          ]}
        >
          <Select options={timezone} />
        </Form.Item>
        <Form.Item
          name="region"
          label="Office Name"
          rules={[
            {
              required: true,
              message: 'Please input your Office Name!'
            }
          ]}
        >
          <Input placeholder="" />
        </Form.Item>
        <Form.Item
          name="country"
          label="Country"
          rules={[
            {
              required: true,
              message: 'Please select your country!'
            }
          ]}
        >
          <Select showSearch placeholder="Select your country">
            {countryOptions.map((country) => (
              <Select.Option key={country.value} value={country.value}>
                {country.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="teams"
          label="Team Name"
          rules={[
            {
              required: true,
              message: 'Please input your teamName!'
            }
          ]}
        >
          <Select
            mode="multiple"
            allowClear
            style={{
              width: '100%'
            }}
            placeholder="Please select"
            options={options}
          />
        </Form.Item>
        <Form.Item className="flex justify-center">
          <Button htmlType="submit">Submit</Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </div>
  );
};

export default AddCousultant;
